import { render, staticRenderFns } from "./LeadsCard.vue?vue&type=template&id=ee487e58&scoped=true&"
import script from "./LeadsCard.vue?vue&type=script&lang=js&"
export * from "./LeadsCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCard.vue?vue&type=style&index=0&id=ee487e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee487e58",
  null
  
)

export default component.exports